import styled from "styled-components";

export const Container = styled.main`
  display: grid;
  grid-template-columns: 20% 60% 20%;
  height: 60px;
  background-color: ${(props) => props.theme.smalt};
  position: sticky;
  top: 0;
  z-index: 100;
  font-size: 16px;
  padding: 0 16px;
`;

const commonColumnStyles = `
  display: flex;
  box-sizing: border-box;
  align-items: center;
`;

export const Left = styled.div`
  ${commonColumnStyles}
  justify-content: left;

  img {
    height: 18px;
    cursor: pointer;
  }
`;

export const Center = styled.div`
  ${commonColumnStyles}
  justify-content: center;
`;

export const Right = styled.div`
  ${commonColumnStyles}
  justify-content: right;
`;

export const Picks = styled.div`
  font-family: "Montserrat";
  color: ${(props) => props.theme.logoGreen};
`;

export const Smart = styled.div`
  font-family: "Montserrat";
  color: ${(props) => props.theme.white};
`;
